<template>
    <el-carousel
        :class="[
            defaultType,
            'ad-banner-wrap',
            advList.length <= 1 ? 'one-banner' : '',
        ]"
        :height="height"
        :loop="true"
    >
        <!-- 是否有广告信息：有显示广告图片 无显示默认图 -->
        <template v-if="advList.length > 0">
            <el-carousel-item v-for="advInfo in advList" :key="advInfo.image">
                <div :class="[defaultType, 'adv-box']">
                    <a
                        class="link"
                        target="_blank"
                        v-if="advInfo.url"
                        :href="advInfo.url"
                        :style="{
                            backgroundImage: 'url(' + advInfo.image + ')',
                        }"
                    ></a>
                    <a
                        v-else
                        class="link no-pointer"
                        href="javascript:void(0)"
                        :style="{
                            backgroundImage: 'url(' + advInfo.image + ')',
                        }"
                    ></a>
                </div>
            </el-carousel-item>
        </template>
        <template v-else>
            <el-carousel-item>
                <div :class="[defaultType, 'adv-box']">
                    <a
                        @click="toContactUs"
                        :class="[defaultType, 'link']"
                        href="javascript:void(0)"
                    ></a>
                </div>
            </el-carousel-item>
        </template>
    </el-carousel>
</template>
<script>
import { getadvinfo } from "@/network/homeIndex";
export default {
    props: {
        category_id: {
            default: "",
        },
        defaultType: {
            default: "default1",
        },
        type: {
            default: "0",
            type: String,
        },
    },
    data() {
        return {
            advList: [],
        };
    },
    computed: {
        height() {
            const heightDic = {
                default1: "160px",
                default2: "290px",
                default3: "732px",
                default4: "170px",
            };
            return heightDic[this.defaultType];
        },
    },
    mounted() {
        getadvinfo({
            category_id: this.category_id,
            type: this.type,
        }).then((res) => {
            this.advList = res.data || [];
        });
    },
    methods: {
        toContactUs() {
            if (this.isExhibition) {
                this.$route.push("/aboutAssociation/4");
            } else {
                this.$route.push("/exhibition/letMe");
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import url("./adv.less");
.ad-banner-wrap ::v-deep .el-carousel__arrow {
    display: none;
}

.ad-banner-wrap ::v-deep .el-carousel__indicator button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
}

.ad-banner-wrap ::v-deep .el-carousel__indicator--horizontal {
    padding: 0px 9px;
}

.ad-banner-wrap ::v-deep .el-carousel__indicators--horizontal {
    bottom: 27px;
}

.ad-banner-wrap img {
    width: 100%;
    height: 100%;
}
</style>